import {action} from 'mobx';
import {AudioService, AudioNotificationEvents} from '../../../services/ts-audio/AudioService';
import VideoModeState from '../dashboard-state/video-mode.state';
import {ITsInterfaceHelperService} from '../../../services/ts-interface-helper/ts-interface-helper.service';
export interface IVideoModeController {
    toggleMute(event?: any): void;
}

export default class VideoModeController implements IVideoModeController {
    constructor(
        public videoModeState: VideoModeState,
        private audioService: AudioService,
        public interfaceHelper: ITsInterfaceHelperService
    ) {
        this.videoModeState.isMicrophoneMuted = this.audioService.isMicMuted();
        this.videoModeState.isSupportAudio = this.audioService.isAudioSupportedByDashboard;
        this.videoModeState.isAudioStreamConnected = this.audioService.hasAudioStream();

        this.audioService.on('audioEvent', this.handleAudioEvent);
    }

    @action
    private handleAudioEvent = (event: {type: AudioNotificationEvents}) => {
        if (event.type === AudioNotificationEvents.IS_PLAYING) {
            this.videoModeState.isAudioStreamConnected = true;
        } else if (event.type === AudioNotificationEvents.DISCONNECTED) {
            this.videoModeState.isAudioStreamConnected = false;
        }
    };

    @action
    toggleMute = (event?: any) => {
        if (event) {
            event.stopPropagation();
        }
        this.audioService.toggleMute(event);
        // Update local state after audio service updates
        this.videoModeState.isMicrophoneMuted = !this.videoModeState.isMicrophoneMuted;
    };
}
